import {
	applySwitchIpv4AclFilter,
	focusSwitchIpv4Acl,
	openSwitchIpv4AclSection,
} from './adapter';
import {
	openSwitchIpv4AclCreateModal,
	openSwitchIpv4AclDeleteModal,
	openSwitchIpv4AclAddAceModal,
	openSwitchIpv4AclEditAceModal,
	openSwitchIpv4AclDeleteAceModal,
} from './modal';
import {resolveSwitchIpv4Acl} from './resolver';

/**
 * Switch IPv4 ACL.
 *
 * Same shape as the Switch MAC ACL: add an entry, or delete the ACL.
 *
 * Declares no fields: the agent finds one and opens the form rather than
 * filling it in.
 */
const switchIpv4AclPlugin = {
	id: 'switch_ipv4_acl',
	version: 1,
	commandVersion: 1,
	resource: 'switch_ipv4_acl',
	operations: ['options', 'list', 'edit', 'search', 'create', 'delete', 'add_ace', 'edit_ace', 'delete_ace'],
	dependencies: {
		plugins: ['canvas.navigation'],
		destinations: ['profile.dashboard'],
	},
	sections: {
		'profile.switch_ipv4_acls': openSwitchIpv4AclSection,
	},
	resolvers: {
		switch_ipv4_acl: resolveSwitchIpv4Acl,
	},
	filters: {
		switch_ipv4_acl: (command) =>
			applySwitchIpv4AclFilter(command.params?.query),
	},
	focusHandlers: {
		switch_ipv4_acl: (command) =>
			focusSwitchIpv4Acl(command.params?.entity_id),
	},
	modals: {
		'switch_ipv4_acl.create': openSwitchIpv4AclCreateModal,
		'switch_ipv4_acl.delete': openSwitchIpv4AclDeleteModal,
		'switch_ipv4_acl.add_ace': openSwitchIpv4AclAddAceModal,
		'switch_ipv4_acl.edit_ace': openSwitchIpv4AclEditAceModal,
		'switch_ipv4_acl.delete_ace': openSwitchIpv4AclDeleteAceModal,
	},
};

export default switchIpv4AclPlugin;
